module.exports = __webpack_public_path__ + "static/media/ic-open-in-new-purple.7d9af1ec.svg";